<template>
    <div class="wrap">
        <iframe :src="pSrc" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
    export default {
        name: "pdf",
        data() {
            return {
                pSrc: '',
                path:process.env.BASE_URL,
            };
        },
        props:['num','part'],
        watch:{
            part(){

                this.loadPDF();
            }
        },
        methods: {
            loadPDF() {
                
                //baseurl ：pdf存放的文件路径，可以是本地的，也可以是远程，这个是远程的，亲测可以用
                //let baseurl = 'http://172.168.10.10/virtualexam/www/api/admin/asset/123.pdf';
                let baseurl = this.path + 'asset/file/'+this.part+'.pdf';
                //ie有缓存加个随机数解决 + '?r=' + new Date()
                let pSrc = baseurl + '?r=' + new Date();
                this.pSrc=this.path+'asset/pdf/web/viewer.html?file=' + encodeURIComponent(pSrc) + '.pdf';
            },
        },

        mounted: function () {
            this.loadPDF();
        }

    };
</script>

<style scoped>
.wrap{height:100%;overflow:hidden;}
</style>